export const enableSuccessToastInfo = (flag) =>{
    return{
        type:'SET_SUCCESS_TOAST',
        value:flag
    }
};

export const enableAgreementRejectToastInfo = (flag) =>{
    return{
        type:'SET_AGREEMENT_REJECT_TOAST',
        value:flag
    }
};

export const enableAgreementSuccessToastInfo = (flag) =>{
    return{
        type:'SET_AGREEMENT_SUCCESS_TOAST',
        value:flag
    }
};

export const enableRejectToastInfo = (flag) =>{
    return{
        type:'SET_REJECT_TOAST',
        value:flag
    }
};

export  const showApiErrorMessage = (flag) => {
    return{
        type:'SET_API_ERROR_TOAST',
        value: flag
    }
}

